export { SaLoadingLogo } from './landing/SaLoadingLogo';
export { SaLoadingOverlayLogo } from './landing/SaLoadingOverlayLogo';
export { SaLogo } from './landing/SaLogo';

export { GamingCuracaoLogo } from './certificate/GamingCuracaoLogo';
export { GamingLabLogo } from './certificate/GamingLabLogo';
